import { DEMOGRAPHIC_QUERY } from "@/graphql/demographic-query";
import { DemographicData } from "@/models/demographic/demographic.interface";
import gql from "graphql-tag";
import { Component, Prop, Vue } from "vue-property-decorator";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";
import { utils } from "@/utils/utils";

@Component({
  name: "demographic-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
  },
})
export default class DemographicDataComponent extends Vue {
  public demographicData: DemographicData[] = [];

  @Prop()
  public demographicKey!: {
    payloadName: string;
    payloadSignatureKey: string;
  };
  @Prop()
  public demographic!: any;
  @Prop()
  public formType!: string;
  @Prop()
  public editForm!: boolean;

  public demographicPayload: any = {
    hispanicorLatino: {
      hispanicorLatino: "",
    },
    ethnicGroupYourself: {
      centralAmerican: "",
      cuban: "",
      dominican: "",
      mexican: "",
      southAmerican: "",
      others: "",
    },
    raceYourself: {
      blackAmerican: "",
      asian: "",
      nativeHawaiian: "",
      pacificIslander: "",
      white: "",
      americanIndian: "",
      dob: "",
    },
  };
  public currentRoute = "";
  public isDisable = false;

  /*
   * Applicants must be 18 or over. The date picker takes the rule directly and
   * greys out anything newer, so an ineligible date of birth cannot be chosen
   * or typed. The check below stays as the backstop, for a value restored from
   * a draft saved before the rule existed.
   */
  public readonly applicantMinAge = 18;

  /*
   * Under 18 by the date of birth given.
   */
  public get isErrDobAge(): boolean {
    const dobDate = utils.monthYearToDate(
      this.demographicPayload?.raceYourself?.dob
    );
    if (!dobDate) {
      return false;
    }
    const minAgeDate = new Date();
    minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
    return dobDate > minAgeDate;
  }

  /*
   * Reviewers cannot edit an applicant's date of birth, so an under-18 warning
   * on their side is a permanent flag they have no way to act on. It stays on
   * the applicant's own form, where it can still be corrected.
   */
  public get isReviewerView(): boolean {
    return this.$route.path.split("/")[1] === "reviewer-dashboard";
  }

  public async created() {
    this.currentRoute = this.$route.path;
    if (this.currentRoute.split("/")[1] === "form") {
      let payloadStorage: any = localStorage.getItem(
        this.demographicKey.payloadName
      );
      payloadStorage = JSON.parse(payloadStorage);
      if (
        this.demographicKey.payloadSignatureKey &&
        payloadStorage &&
        payloadStorage[this.demographicKey.payloadSignatureKey].demographic
      ) {
        this.demographicPayload =
          payloadStorage[this.demographicKey.payloadSignatureKey].demographic;
      }
    } else {
      this.demographicPayload = this.demographic;
    }
    await this.$apollo
      .query({
        query: gql`query ${DEMOGRAPHIC_QUERY}`,
      })
      .then((result) => {
        this.demographicData = result.data.demographicDatas.data;
        this.isDisable = utils.disableField(this.editForm, this.formType);
      });
  }

  public updated() {
    if (
      this.demographicPayload.hispanicorLatino.hispanicorLatino === "No" ||
      this.demographicPayload.hispanicorLatino.hispanicorLatino === "Refused"
    ) {
      Object.keys(this.demographicPayload.ethnicGroupYourself).forEach(
        (key) => {
          this.demographicPayload.ethnicGroupYourself[key] = "";
        }
      );
    }
    this.$emit("input", this.demographicPayload);
  }

  /*
   * The date of birth is rendered with the shared picker in its month-only
   * mode, whatever the CMS says the control is: the day is not collected, so
   * the field asks for, shows and sends MM-YYYY. Deciding it here keeps the
   * control in step with that rule without waiting on a content change, and
   * normalises the values saved in other formats before it.
   */
  public fieldComponent(fields: any): string {
    return fields.name === "dob" ? "b-form-input-datepicker" : fields.field;
  }

  public fieldBindings(formInput: any, fields: any): any {
    if (fields.name === "dob") {
      // Drop the CMS propBind: its input attributes would fight the picker
      // being rendered instead.
      return {};
    }
    return fields.options ? formInput.propBind.fieldGroups : fields.propBind;
  }

  public fieldUpdate(groupName: string) {
    if (groupName === "ethnicGroupYourself") {
      if (
        this.demographicPayload.hispanicorLatino.hispanicorLatino === "" ||
        this.demographicPayload.hispanicorLatino.hispanicorLatino === "No" ||
        this.demographicPayload.hispanicorLatino.hispanicorLatino === "Refused"
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
}
